import styled from "styled-components";

const AttributeHeader = styled.div.attrs(() => ({ className: "mt-1 best-attribute-header" }))`
  font-weight: bold;
`;

export default AttributeHeader;
